// extracted by mini-css-extract-plugin
module.exports = {"snippets_list":"snippets-list-module--snippets_list--X285g","content":"snippets-list-module--content--XhKNG","tags_box":"snippets-list-module--tags_box--2SvFa"};